import Swiper from 'swiper/bundle';

export default class Slider {
    constructor (dom) {
        window.addEventListener("resize", () => this.resize());
        this.dom = dom

        this.el_id = Math.floor(Math.random() * 99999)
        this.dom.dataset.id = this.el_id
    }

    init () {
        const type = this.dom.dataset.type

        switch (type) {
            case 'full-width':
                this.fullWidthSlider()
                break;
            case 'image-slider':
                this.imageSlider()
                break;
            default:
                break;
        }
    }

    fullWidthSlider() {
        let thumbSlider = new Swiper(this.dom.querySelector('.thumb-slider'), {
            spaceBetween: 0,
            slidesPerView: 1,
            // keyboard: {
            //     enabled: false,
            //     onlyInViewport: false,
            // },
        });

    }


    imageSlider() {
        let thumbSlider = new Swiper(this.dom.querySelector('.thumb-slider'), {
            spaceBetween: 20,
            slidesPerView: 4.5,
            // keyboard: {
            //     enabled: false,
            //     onlyInViewport: false,
            // },
            navigation: {
                nextEl: this.dom.querySelector('.btn-next'),
                prevEl: this.dom.querySelector('.btn-prev'),
            },
        });
    }
    initResponsiveHelper() {

    }

    resize() {
    }

}
